import Immutable from 'seamless-immutable'
import { TOGGLE_PRIVACY_NOTICES } from './actions'

const initialState = Immutable.from({
  toggles: '111',
})

const privacyNotice = (state = initialState, { type, payload }) => {
  switch (type) {
    case TOGGLE_PRIVACY_NOTICES:
      payload = payload || '111'
      return state.set('toggles', payload)
    default:
      return state
  }
}

export default privacyNotice
